module.exports = __webpack_public_path__ + "img/job-search.3848dd08.png";